// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3kBB6","label":"styles_label__1p6A2"};